import { forwardRef, useImperativeHandle, useRef, useState } from 'react'
import { ConfirmDialog } from '@ui-kit'
import { DUPLICATE_POPUP, NAMESPACES } from '../../utils/constants'

export interface AttachCaseConfirmDialogHandle {
  open: (caseId: string | number) => void
  dismiss: () => void
  isOpen: () => boolean
}

interface AttachCaseConfirmDialogProps {
  onConfirm: (caseId: string | number) => void
}

export const AttachCaseConfirmDialog = forwardRef<
  AttachCaseConfirmDialogHandle,
  AttachCaseConfirmDialogProps
>(({ onConfirm }, ref) => {
  const [open, setOpen] = useState(false)
  const openRef = useRef(false)
  const pendingCaseIdRef = useRef<string | number | null>(null)

  useImperativeHandle(ref, () => ({
    open: (caseId: string | number) => {
      pendingCaseIdRef.current = caseId
      openRef.current = true
      setOpen(true)
    },
    dismiss: () => {
      openRef.current = false
      setOpen(false)
      pendingCaseIdRef.current = null
    },
    isOpen: () => openRef.current,
  }))

  const handleCancel = () => {
    openRef.current = false
    setOpen(false)
    pendingCaseIdRef.current = null
  }

  const handleConfirm = () => {
    const caseId = pendingCaseIdRef.current
    openRef.current = false
    setOpen(false)
    pendingCaseIdRef.current = null

    if (caseId == null) {
      return
    }

    onConfirm(caseId)
  }

  return (
    <div onMouseDown={(e) => e.stopPropagation()}>
      <ConfirmDialog
        open={open}
        message={DUPLICATE_POPUP.ATTACH_CONFIRM_MESSAGE}
        onCancel={handleCancel}
        onConfirm={handleConfirm}
        cancelButtonText={NAMESPACES.CANCEL_BUTTON}
        confirmButtonText={NAMESPACES.YES}
      />
    </div>
  )
})

AttachCaseConfirmDialog.displayName = 'AttachCaseConfirmDialog'

export interface ConfirmDialogHandle {
  open: () => void
  dismiss: () => void
  isOpen: () => boolean
}

interface ProceedAnywayConfirmDialogProps {
  onConfirm: () => void
}

export const ProceedAnywayConfirmDialog = forwardRef<
  ConfirmDialogHandle,
  ProceedAnywayConfirmDialogProps
>(({ onConfirm }, ref) => {
  const [open, setOpen] = useState(false)
  const openRef = useRef(false)

  useImperativeHandle(ref, () => ({
    open: () => {
      openRef.current = true
      setOpen(true)
    },
    dismiss: () => {
      openRef.current = false
      setOpen(false)
    },
    isOpen: () => openRef.current,
  }))

  const handleCancel = () => {
    openRef.current = false
    setOpen(false)
  }

  const handleConfirm = () => {
    openRef.current = false
    setOpen(false)
    onConfirm()
  }

  return (
    <div onMouseDown={(e) => e.stopPropagation()}>
      <ConfirmDialog
        open={open}
        message={DUPLICATE_POPUP.PROCEED_INTAKE_CONFIRM_MESSAGE}
        onCancel={handleCancel}
        onConfirm={handleConfirm}
        cancelButtonText={NAMESPACES.CANCEL_BUTTON}
        confirmButtonText={NAMESPACES.YES}
      />
    </div>
  )
})

ProceedAnywayConfirmDialog.displayName = 'ProceedAnywayConfirmDialog'
